"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var trLocaleData = require("i18next-icu/locale-data/tr");
exports.default = trLocaleData;
//# sourceMappingURL=tr.js.map